import VoxeetSDK from '@voxeet/voxeet-web-sdk';
import { useEffect, useRef, useState } from 'react';
import { useUserStore } from '../../stores/user';

import styles from './user.module.css';

export function UserStream({
    name,
    className = '',
    showName = true,
    participant
}){
    const { id: userId } = useUserStore();
    const videoRef = useRef(null);
    const [hasVideo, setHasVideo] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    useEffect(() => {
        if(participant.stream){
            navigator.attachMediaStream(videoRef.current, participant.stream);
            setHasVideo(true)
        }
        else{
            setHasVideo(false)
        }
    },[participant.stream])
    useEffect(() => {
        if(participant){
            const timer = setInterval(() => {
                VoxeetSDK.conference.isSpeaking(participant.original, isSpeaking => {
                    setIsSpeaking(isSpeaking)
                });
            }, 500);
            return () => {
                clearInterval(timer);
            }
        }
    }, [participant])
    return <div className={`${styles.user} ${className} ${hasVideo ? styles.hasvideo : ''} ${isSpeaking ? styles.speaking : ''}`}>
        {!hasVideo && <div className={`${styles.avatar} ${isSpeaking ? styles.speaking : ''}`}>
            <span>{name.split(' ').map(str => str[0]).join('')}</span>
        </div>}
        <video playsInline muted autoPlay ref={videoRef} />
        <div className={styles.overlay} />
        {participant.pesuId !== userId && <span className={styles.name}>{name}</span>}
    </div>
}